import cx from "classnames";
import type { FC, ReactNode } from "react";

import { baseStyles, disabledStyles, hoverStyles, iconStyles } from "./css";

import { Hotkeys } from "../Hotkeys";
import { BasicTooltip } from "../Tooltip";

export type ToolbarItemProps = {
	label: string;
	hotkey?: string;
	isActive?: boolean;
	isDisabled?: boolean;
	disableTooltip?: boolean;
	children?: ReactNode;
} & React.HTMLAttributes<HTMLButtonElement>;

export const ToolbarItem: FC<ToolbarItemProps> = ({
	label,
	hotkey,
	isActive = false,
	isDisabled = false,
	disableTooltip = false,
	children,
	...props
}) => {
	const b = (
		<button
			aria-label={label}
			className={cx(
				"w-8",
				"h-8",
				baseStyles(isActive),
				hoverStyles(isActive),
				iconStyles(isActive),
				disabledStyles(isActive, isDisabled)
			)}
			disabled={isDisabled}
			{...props}
		>
			{children}
		</button>
	);

	if (isDisabled || disableTooltip) {
		return b;
	}

	return (
		<BasicTooltip
			content={
				<span className="space-x-2">
					<span>{label}</span>
					{hotkey && <Hotkeys hotkey={hotkey} type="inverse" />}
				</span>
			}
		>
			{b}
		</BasicTooltip>
	);
};
